import { DialogContent as MuiDialogContent } from '@mui/material';
import { pick } from 'ramda';
import { styled } from '../../utils';
const DialogContentStyled = styled(MuiDialogContent)(({ theme }) => ({
    display: 'grid',
    padding: theme.spacing(2),
    ...pick([
        'fontFamily',
        'fontSize',
        'fontWeight',
        'letterSpacing',
        'color',
        'lineHeight',
    ], theme.typography.body1),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.5),
        gap: theme.spacing(1.5),
        '& > *': {
            '::-webkit-scrollbar': {
                display: 'none',
            },
        },
    },
}));
export const DialogContent = DialogContentStyled;
